export class CreateChannelDTO {
  constructor(channel) {
    this.name = channel.name;
    this.description = channel.description;
    this.department = channel.department;
  }

  createEmpty() {
    return new CreateChannelDTO({ name: '', description: '', department: '' });
  }
}

export class UpdateChannelDTO extends CreateChannelDTO {
  constructor(channel) {
    super(channel)
    this.id = channel.id
    this.image = channel.image
    this.department = channel.department.id
  }
}